import styles from "src/features/Event/components/ViewModeToggleButton/viewModeToggleButton.module.css";
import { useAtom } from "jotai";
import { viewModeText } from "../../event.constant";
import { eventCardLayoutAtom } from "../../event.atom";

const ViewModeToggleButton: React.FC = () => {
    const [eventCardLayout, setEventCardLayout] = useAtom(eventCardLayoutAtom);

    const layoutText =
        eventCardLayout === "small" ? viewModeText.full : viewModeText.minimal;

    const handleClick = () => {
        setEventCardLayout();
    };

    return (
        <div
            className={`${styles.view_mode_toggle_button_container}`}
            onClick={handleClick}
            onKeyDown={handleClick}
            role="button"
            tabIndex={0}
        >
            <div className={styles.view_mode_toggle_button}>
                <div className={styles.view_mode_toggle_button_icon_container}>
                    <div className={styles.view_mode_toggle_button_icon} />
                </div>
                <p className={styles.view_mode_toggle_button_text}>
                    {layoutText}
                </p>
            </div>
        </div>
    );
};

export default ViewModeToggleButton;
